{
  "hero.title": "多 CLI 环境切换器",
  "hero.tagline-1": "进入禅意般的心流编程状态。",
  "hero.tagline-2": "无缝环境切换。",
  "hero.subtitle": "统一管理 Claude Code、Codex、OpenCode 配置，带 API 代理自动故障转移",
  "hero.getDocs": "查看文档",
  "features.title": "功能特性",
  "features.multiCli.title": "多 CLI 支持",
  "features.multiCli.desc": "支持 Claude Code、Codex、OpenCode，可按项目配置",
  "features.multiConfig.title": "多配置管理",
  "features.multiConfig.desc": "在统一的 JSON 文件中管理所有 API provider 配置",
  "features.daemon.title": "统一守护进程",
  "features.daemon.desc": "单个 zend 进程同时托管代理服务和 Web 管理界面",
  "features.failover.title": "代理故障转移",
  "features.failover.desc": "内置 HTTP 代理，主 provider 不可用时自动切换备用",
  "features.routing.title": "场景路由",
  "features.routing.desc": "根据请求特征（thinking、image 等）智能路由到不同 provider",
  "features.binding.title": "项目绑定",
  "features.binding.desc": "将目录绑定到特定 profile 和 CLI，实现项目级自动配置",
  "features.envVars.title": "环境变量",
  "features.envVars.desc": "在 provider 级别为每个 CLI 单独配置环境变量",
  "features.webUi.title": "Web 界面",
  "features.webUi.desc": "浏览器可视化管理，支持密码保护访问",
  "features.webSecurity.title": "Web 安全",
  "features.webSecurity.desc": "自动生成访问密码、会话认证、RSA 加密令牌传输",
  "features.configSync.title": "配置同步",
  "features.configSync.desc": "通过 WebDAV/S3/GitHub 跨设备同步配置，使用 AES-256-GCM 加密",
  "features.comingSoon": "更多功能，敬请期待",
  "install.title": "快速开始",
  "install.step1.title": "安装 GoZen",
  "install.step1.desc": "一键安装脚本",
  "install.step2.title": "配置 Provider",
  "install.step2.desc": "添加第一个 API provider",
  "install.step3.title": "启动",
  "install.step3.desc": "使用默认配置启动 CLI",
  "commands.title": "命令一览",
  "commands.command": "命令",
  "commands.description": "说明",
  "commands.items.start": "启动 CLI（使用项目绑定或默认配置）",
  "commands.items.profile": "使用指定 profile 启动",
  "commands.items.profilePick": "交互选择 profile",
  "commands.items.cli": "使用指定 CLI（claude/codex/opencode）",
  "commands.items.yes": "自动批准 CLI 权限（claude --permission-mode acceptEdits, codex -a never）",
  "commands.items.use": "直接使用指定 provider（无代理）",
  "commands.items.pick": "交互选择 provider 启动",
  "commands.items.list": "列出所有 provider 和 profile",
  "commands.items.configAddProvider": "添加新 provider",
  "commands.items.configAddProfile": "添加新 profile",
  "commands.items.configDefaultClient": "设置默认 CLI 客户端",
  "commands.items.configDefaultProfile": "设置默认 profile",
  "commands.items.configResetPassword": "重置 Web UI 访问密码",
  "commands.items.configSync": "从远程同步后端拉取配置",
  "commands.items.daemonStart": "启动 zend 守护进程",
  "commands.items.daemonStop": "停止守护进程",
  "commands.items.daemonStatus": "查看守护进程状态",
  "commands.items.daemonEnable": "安装为系统服务",
  "commands.items.daemonDisable": "卸载系统服务",
  "commands.items.bind": "绑定当前目录到 profile",
  "commands.items.bindCli": "绑定当前目录使用指定 CLI",
  "commands.items.unbind": "解除当前目录绑定",
  "commands.items.status": "显示当前目录绑定状态",
  "commands.items.web": "在浏览器中打开 Web 管理界面（自动启动守护进程）",
  "commands.items.upgrade": "升级到最新版本",
  "commands.items.version": "显示版本",
  "commands.items.completion": "生成 Shell 补全脚本（zsh/bash/fish）",
  "homepage.title": "多 CLI 环境切换器"
}
